
























































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';

import { useFormat } from '@ideavivat/vivat-2';

import { getCustomer, getSupplier } from '@/api';
import useAddress from '@/use/useAddress';
import useAuth from '@/use/useAuth';
import { Supplier } from '@/types/supplier';

const defaultPartner : Supplier = {
  id: -1,
  name: '',
  branch: '',
  code: '',
  taxId: '',
  phone: '',
  email: '',
  credit_days: '',
  show_as_english: false,
  address: '',
  province: {},
  district: {},
  sub_district: {},
  zipcode: '',
  credit_logs: [],
};

const CommonModalWithPartnerInfo = defineComponent({
  setup(props, { root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const modal = ref(null);
    const partner = reactive(defaultPartner);
    const type = ref('CUSTOMER');
    const { getAddressString } = useAddress();

    async function compose(id: number, entityType: string) {
      let result = null;
      type.value = entityType;
      if (entityType === 'CUSTOMER') result = (await getCustomer(id)).data;
      if (entityType === 'SUPPLIER') result = (await getSupplier(id)).data;
      partner.id = result.id;
      partner.name = result.name;
      partner.show_as_english = result.show_as_english;
      partner.code = result.code;
      partner.branch = result.branch;
      partner.phone = result.phone;
      partner.email = result.email;
      partner.taxId = result.taxId;
      partner.credit_days = result.credit_days;
      partner.address = result.address || '';
      partner.province = result.province || undefined;
      partner.district = result.district || undefined;
      partner.sub_district = result.sub_district || undefined;
      partner.zipcode = result.zipcode || '';
      partner.credit_logs = result.credit_logs;
      (modal.value as any).open();
    }
    const computedSupplierAddress = computed(() => {
      if ((!partner && !((partner as any).province))) return '';
      if (!((partner as any).district)) return '';
      if (!((partner as any).sub_district)) return '';
      const key = partner?.show_as_english ? 'name_in_english' : 'name_in_thai';
      let subDistrict: undefined | string = '';
      if (partner.sub_district) subDistrict = partner.sub_district[key] !== 'NULL' ? partner.sub_district[key] : partner.sub_district.name_in_thai;
      return `${partner.address}${key === 'name_in_english' ? ' Tumbol ' : ' '}${subDistrict} ${partner.district[key]} ${partner.province[key]} ${partner.zipcode}`;
    });

    function close() {
      (modal.value as any).close();
      partner.id = defaultPartner.id;
      partner.name = defaultPartner.name;
      partner.code = defaultPartner.code;
      partner.branch = defaultPartner.branch;
      partner.phone = defaultPartner.phone;
      partner.credit_days = defaultPartner.credit_days;
      partner.email = defaultPartner.email;
      partner.taxId = defaultPartner.taxId;
      partner.address = defaultPartner.address;
      partner.credit_logs = defaultPartner.credit_logs;
    }

    const computedCreditLogs = computed(() => {
      let latestDate = '';
      return partner.credit_logs.reverse().map((log: any, index: any) => {
        latestDate = useFormat.date(log.date).displayShortThaiDate();
        if (index === 0) {
          return {
            start: useFormat.date(partner.credit_logs[0].date).displayShortThaiDate(),
            credit: partner.credit_logs[0].credit_days,
            end: 'ปัจจุบัน',
          };
        }
        return {
          start: useFormat.date(log.date).displayShortThaiDate(),
          credit: log.credit_days,
          end: latestDate,
        };
      });
    });

    return {
      modal,
      compose,
      close,

      hasPermission,
      computedSupplierAddress,

      type,
      partner,

      computedCreditLogs,
    };
  },
});

export default CommonModalWithPartnerInfo;
